import {
  approveAllReportedReviewsAPI,
  approveSingleReviewReportAPI,
  deleteReviewAPI,
  GETReportedReviewDetails,
  getReportedReviewDetailsAPI
} from '@myme/api';
import { sendRequest, UUID } from '@myme/utils';

const getReviewIdRecord = (reviewId: UUID) => ({
  key: 'reviewId',
  value: reviewId
});

const getUserReportIdRecord = (userReportId: UUID) => ({
  key: 'userReportId',
  value: userReportId
});
/* **** DELETE **** /admin/reviews/:reviewId */
export const deleteReview = async (reviewId: UUID) =>
  sendRequest<null, null>(deleteReviewAPI, { args: [getReviewIdRecord(reviewId)] });

/* **** PATCH **** /admin/reviews/:reviewId */
export const approveReportedReview = async (reviewId: UUID, userReportId: UUID) =>
  sendRequest<null, null>(approveSingleReviewReportAPI, {
    args: [getReviewIdRecord(reviewId), getUserReportIdRecord(userReportId)]
  });

/* **** PATCH **** /admin/reviews/approve-reports */
export const approveAllReportedReviews = async (reviewId: UUID) =>
  sendRequest<null, null>(approveAllReportedReviewsAPI, { args: [getReviewIdRecord(reviewId)] });

/* **** GET **** /admin/reviews/:reviewId/details */
export const getReportedReviewDetails = async (reviewId: UUID) =>
  sendRequest<GETReportedReviewDetails, null>(getReportedReviewDetailsAPI, { args: [getReviewIdRecord(reviewId)] });
